import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';

const LoadingContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '100vh',
  background: '#0f172a',
  position: 'relative',
  overflow: 'hidden',
});

const GlowingProgress = styled(CircularProgress)({
  color: '#0891b2',
  animation: 'pulse 2s ease-in-out infinite',
  '@keyframes pulse': {
    '0%, 100%': {
      opacity: 1,
    },
    '50%': {
      opacity: 0.7,
    },
  },
});

const LoadingSpinner: React.FC = () => {
  return (
    <LoadingContainer>
      <GlowingProgress size={60} thickness={4} />
    </LoadingContainer>
  );
};

export default LoadingSpinner;

